module.exports = __webpack_public_path__ + "assets/img/202110-6W.e3408aaf.png";